export default "__VITE_ASSET__KfcyWX9o__"